import '../scss/style.scss'; // CSSが出力できなくなるので削除禁止

$(function () {
	smoothScroll();
	bodyAddClass();
	copyLink();
	changeListOrder();

	/**
	 * マイソク 画像スライダー
	 */
	$(".p-slider__main").slick({
		slidesToShow: 1,
		slidesToScroll: 1,
		fade: true,
		/*adaptiveHeight: true,*/
		prevArrow: '<p class="slide-arrow prev-arrow"><span>&#12296;</span></p>',
		nextArrow: '<p class="slide-arrow next-arrow"><span>&#12297;</span></p>',
		asNavFor: ".p-slider__sub",
	});
	$(".p-slider__sub").slick({
		slidesToShow: 8,
		slidesToScroll: 1,
		asNavFor: ".p-slider__main",
		focusOnSelect: true,
	});

	/**
	 * マイソク スライダー画像拡大
	 */
	if (device() === "desktop" || device() === "tablet") {
		$(".js-zoom").click(function () {
			var imgSrc = $(this).children().attr("src");
			$(".p-modal__image").children().attr("src", imgSrc);
			$(".p-modal").fadeIn();
			//$("body,html").css("overflow-y", "hidden");
			return false;
		});

		$(".p-modal__close,.p-modal").click(function () {
			$(".p-modal").fadeOut();
			$("body,html").css("overflow-y", "visible");
			return false;
		});
	}

	// ボタンにイベントリスナーを追加
	document.getElementById('js-pdf').addEventListener('click', generatePDF);

	
});

/**
 * スムーススクロール
 */
function smoothScroll() {
	$('a[href^="#"]').click(function () {
		var href = $(this).attr("href");
		var target = $(href == "#" || href == "" ? "html" : href);
		var position = target.offset().top;
		var speed = 500;
		$("html, body").animate(
			{
				scrollTop: position,
			},
			speed,
			"swing"
		);
		return false;
	});
}

/**
 * bodyタグにclassを付与
 */
function bodyAddClass() {
	let ua = window.navigator.userAgent.toLowerCase();

	if (ua.indexOf("msie") > -1 || ua.indexOf("trident") > -1) {
		$("body").addClass("is-ie");
	} else if (
		ua.indexOf("ipad") > -1 ||
		(ua.indexOf("macintosh") > -1 && "ontouchend" in document)
	) {
		$("body").addClass("is-ipad");
	}
}

// デバイス判定
function device() {
	var ua = navigator.userAgent;
	if (
		ua.indexOf("iPhone") > 0 ||
		ua.indexOf("iPod") > 0 ||
		(ua.indexOf("Android") > 0 && ua.indexOf("Mobile") > 0)
	) {
		return "mobile";
	} else if (ua.indexOf("iPad") > 0 || ua.indexOf("Android") > 0) {
		return "tablet";
	} else {
		return "desktop";
	}
}

/**
 * リンクコピー処理
 */
function copyLink() {
	$(document).on('click', '.js-copy-link', function () {
		const link = $(this).data('link');
		navigator.clipboard
			.writeText(link)
			.then(() => {
				alert('リンクをコピーしました');
			})
			.catch(() => {
				alert('リンクのコピーに失敗しました');
			});
	});
}

/**
 * 並び替えセレクトボックス
 */
function changeListOrder() {
	const $select = $('#js-order-select');
	const $permalink = $select.data('url');

  const url = new URL(window.location.href);
  const params = url.searchParams;
  const paramFood = params.get('food');

	$select.change(function () {
		const $val = $(this).val();
    let locationHref = $permalink;
    if (paramFood != null && $val != '') {
      locationHref += '?food=' + paramFood + '&order=' + $val;
    } else if (paramFood != null && $val == '') {
      locationHref += '?food=' + paramFood;
    } else if (paramFood == null && $val != '') {
      locationHref += '?&order=' + $val;
    }
    location.href = locationHref;
	});
}

// ライブラリ読み込み済みかどうか
let pdfLibrariesLoaded = false;


// 必要なライブラリを読み込む
const loadScripts = async () => {

	if (pdfLibrariesLoaded) {
		return;
	}

	// html2canvas
	const html2canvasScript = document.createElement('script');
	html2canvasScript.src =
		'https://cdnjs.cloudflare.com/ajax/libs/html2canvas/1.4.1/html2canvas.min.js';

	document.head.appendChild(html2canvasScript);


	// jsPDF
	const jsPDFScript = document.createElement('script');
	jsPDFScript.src =
		'https://cdnjs.cloudflare.com/ajax/libs/jspdf/2.5.1/jspdf.umd.min.js';

	document.head.appendChild(jsPDFScript);


	// 読み込み完了を待つ
	await Promise.all([
		new Promise((resolve, reject) => {
			html2canvasScript.onload = resolve;
			html2canvasScript.onerror = reject;
		}),
		new Promise((resolve, reject) => {
			jsPDFScript.onload = resolve;
			jsPDFScript.onerror = reject;
		})
	]);

	pdfLibrariesLoaded = true;
};


// 画像の読み込み完了を待つ
async function waitForImages(root) {

	const images = root.querySelectorAll('img');

	await Promise.all(
		Array.from(images).map((img) => {

			if (img.complete && img.naturalWidth > 0) {
				return Promise.resolve();
			}

			return new Promise((resolve) => {
				img.onload = resolve;
				img.onerror = resolve;
			});

		})
	);
}


// object-fit: cover の画像だけ
// background-image に置き換える
function replaceCoverImagesForPdf(root) {

	const images = root.querySelectorAll('img');

	images.forEach((img) => {

		const style = window.getComputedStyle(img);

		// cover以外は何もしない
		if (style.objectFit !== 'cover') {
			return;
		}

		const rect = img.getBoundingClientRect();

		const width = rect.width;
		const height = rect.height;

		if (!width || !height) {
			return;
		}

		// divを作成
		const div = document.createElement('div');

		// 元画像のclassを引き継ぐ
		div.className = img.className;

		// 元画像のスタイルをある程度引き継ぐ
		div.style.width = `${width}px`;
		div.style.height = `${height}px`;

		div.style.backgroundImage =
			`url("${img.currentSrc || img.src}")`;

		div.style.backgroundSize = 'cover';

		div.style.backgroundPosition =
			style.objectPosition || 'center center';

		div.style.backgroundRepeat = 'no-repeat';

		div.style.display = 'block';

		div.style.boxSizing = 'border-box';

		// border-radiusがあれば引き継ぐ
		div.style.borderRadius = style.borderRadius;

		// marginも引き継ぐ
		div.style.marginTop = style.marginTop;
		div.style.marginRight = style.marginRight;
		div.style.marginBottom = style.marginBottom;
		div.style.marginLeft = style.marginLeft;

		// 元画像と差し替え
		img.replaceWith(div);
	});
}


// PDFを生成する関数
async function generatePDF(event) {

	// クリックされたボタン
	const button = event.currentTarget;

	// data-post-id取得
	const postId = button.getAttribute('data-post-id');

	const filename = postId
		? `${postId}.pdf`
		: 'document.pdf';


	try {

		// ライブラリ読み込み
		await loadScripts();


		// PDF化対象
		const originalElement =
			document.querySelector('.p-maisoku-print__box');


		if (!originalElement) {
			console.error(
				'.p-maisoku-print__box が見つかりません'
			);

			return;
		}


		// 元画像の読み込み完了を待つ
		await waitForImages(originalElement);


		/*
		 * ===============================
		 * PDF用DOMを複製
		 * ===============================
		 */

		const clone =
			originalElement.cloneNode(true);


		/*
		 * 画面外に配置
		 *
		 * display:none にすると
		 * html2canvasで正しくサイズ計算できないので
		 * 左側へ飛ばす
		 */
		clone.style.position = 'absolute';
		clone.style.left = '-10000px';
		clone.style.top = '0';

		clone.style.display = 'block';

		// 元要素と同じ横幅を明示
		clone.style.width =
			`${originalElement.offsetWidth}px`;


		document.body.appendChild(clone);


		/*
		 * clone内の画像読み込みを待つ
		 */
		await waitForImages(clone);


		/*
		 * object-fit: cover の画像だけ
		 * background-imageへ変換
		 */
		replaceCoverImagesForPdf(clone);


		/*
		 * ===============================
		 * html2canvas
		 * ===============================
		 */

		const html2canvasOptions = {

			scale: 2,

			logging: false,

			useCORS: true,

			allowTaint: true,

			letterRendering: true,

			removeContainer: true,

			scrollX: 0,

			scrollY: 0,

			backgroundColor: '#ffffff'
		};


		const canvas =
			await html2canvas(
				clone,
				html2canvasOptions
			);


		/*
		 * clone削除
		 */
		clone.remove();


		/*
		 * ===============================
		 * PDF生成
		 * ===============================
		 */

		const pageWidth = 297;
		const pageHeight = 210;


		// Canvasのサイズ
		const imgWidth = canvas.width;
		const imgHeight = canvas.height;


		// 比率
		const aspectRatio =
			imgWidth / imgHeight;


		/*
		 * PDFサイズに合わせる
		 */
		let pdfWidth = pageWidth;

		let pdfHeight =
			pdfWidth / aspectRatio;


		// 高さがはみ出す場合
		if (pdfHeight > pageHeight) {

			pdfHeight = pageHeight;

			pdfWidth =
				pdfHeight * aspectRatio;
		}


		/*
		 * JPEG化
		 */
		const imgData =
			canvas.toDataURL(
				'image/jpeg',
				1.0
			);


		/*
		 * PDF作成
		 */
		const pdf =
			new jspdf.jsPDF({
				orientation: 'landscape',
				unit: 'mm',
				format: 'a4'
			});


		/*
		 * 中央配置
		 */
		const xPosition =
			(pageWidth - pdfWidth) / 2;

		const yPosition =
			(pageHeight - pdfHeight) / 2;


		/*
		 * 画像追加
		 */
		pdf.addImage(
			imgData,
			'JPEG',
			xPosition,
			yPosition,
			pdfWidth,
			pdfHeight,
			undefined,
			'FAST'
		);


		/*
		 * PDF保存
		 */
		pdf.save(filename);


	} catch (error) {

		console.error(
			'PDF生成中にエラーが発生しました:',
			error
		);

		// エラー時にcloneが残っていた場合の保険
		document
			.querySelectorAll(
				'body > .p-maisoku-print__box[style*="-10000px"]'
			)
			.forEach((element) => {
				element.remove();
			});
	}
}
  